import React, { useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";
import "flag-icons/css/flag-icons.min.css";

export default function LanguageSelector() {
  const { i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const languages = [
    { code: "ko", name: "한국어", flag: "kr" },
    { code: "en", name: "English", flag: "us" },
  ];

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    localStorage.setItem("i18nextLng", lng);
    setIsOpen(false);
  };

  const currentLang =
    languages.find((lang) => lang.code === i18n.language) || languages[0];

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div
      className="dropdown"
      ref={dropdownRef}
      style={{ width: "85px", fontSize: "12px" }}
    >
      <button
        className="btn btn-light dropdown-toggle d-flex align-items-center bg-transparent border-0 p-0 pt-2"
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        aria-expanded={isOpen}
        style={{ fontSize: "12px" }}
      >
        <span className={`fi fi-${currentLang.flag} me-1`}></span>
        <span>{currentLang.name}</span>
      </button>

      <ul className={`dropdown-menu dropdown-menu-end ${isOpen ? "show" : ""}`}>
        {languages.map((lang) => (
          <li key={lang.code}>
            <button
              className={`dropdown-item d-flex align-items-center ${
                i18n.language === lang.code ? "active" : ""
              }`}
              onClick={() => changeLanguage(lang.code)}
            >
              <span className={`fi fi-${lang.flag} me-2`}></span>
              <span>{lang.name}</span>
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
